<template>
  <div ref="SalesReceipt" class="d-none">
    <div v-html="EjsData"></div>
    <!-- <div class="white-wrapper mt-4">
      <table style="max-width: 320px; font-size: 11px;">
        <thead>
          <tr>
            <th colspan="5">
              <p style="margin:0;">{{bookingDetails.cine_name}}</p>
              <p style="margin:3px;">{{bookingDetails.cine_phone}}</p>
            </th>
          </tr>

          <tr>
            <th colspan="3" style="text-align:left;padding-bottom: 10px;">
              <p style="font-size: 10px;margin:0">Sales Receipt</p>
              <span>{{ currentDate }}</span>
            </th>
            <th colspan="2" style="text-align:right;padding-bottom: 10px;">
              <p style="font-size: 10px;margin:0;">Transaction No:</p>
              <span>{{ bookingDetails.sb_booking_code }}</span>
            </th>
          </tr>

          <tr>
            <td colspan="5" style="border-top:1px dashed #404040;"></td>
          </tr>

          <tr>
            <th style="width: 45%;text-align:left;">DESCRIPTION</th>
            <th style="width 10%;text-align:center;">QTY</th>
            <th style="width: 15%;text-align:center;">PRICE</th>
            <th style="width: 15%;text-align:center;">TAX</th>
            <th style="width: 15%;text-align:right;">TOTAL</th>
          </tr>

          <tr>
            <td colspan="5" style="border-top:1px dashed #404040;padding-bottom:5px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="5">
              <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">BOOKING SUMMARY:</p>
            </td>
          </tr>
          <tr>
            <td style="text-aling:left;">
              <p
                style="margin: 1px 0;"
              >{{ bookingDetails.movie_title }}-{{bookingDetails.mf_name}}-{{bookingDetails.lang_name}}</p>

              <p
                style="margin:1px 0;"
              >{{ bookingDetails.og_show_date | dateparse }} {{ bookingDetails.og_show_time | timeparseAmPm }}</p>

              <p
                :key="seatTypeIndex"
                style="margin:2px 0;"
                v-for="(seatType, seatTypeIndex) in bookingDetails.uniqueSeatTypes"
              >
                ({{bookingDetails.screen_name}}:
                <span>{{seatType}} - {{bookingDetails.seats}}</span>
                <span v-if="seatTypeIndex + 1 < bookingDetails.uniqueSeatTypes.length">,</span>)
              </p>
            </td>

            <td
              style="text-align:center;"
            >{{ bookingDetails["seats_types"] ? bookingDetails["seats_types"].length : '' }}</td>

            <td style="text-align:center;">{{ netAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>

            <td style="text-align:center;">{{ getTaxAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>

            <td style="text-align:right;">{{ tickettotal }}</td>
          </tr>

          <tr>
            <td colspan="5" style="padding-top: 5px;border-bottom:1px dashed #404040;"></td>
          </tr>

          <tr>
            <td colspan="2" style="text-align:left;">
              <p style="margin: 0 0 15px 0;font-weight: bold;">Booking Total:</p>
            </td>

            <td colspan="3" style="text-align: right;">
              <p
                style="margin:0 0 15px 0;font-weight: bold;"
              >{{getcurrency}} {{ tickettotal.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr
            v-if="getSelectedOffer && getSelectedOffer.offer_print_on_ticket == 'Y' || offerFor == 'vouchers'"
            style="border-bottom: 1px dashed #000000"
          >
            <td colspan="2" style="text-align: left;">
              <div style="font-weight: bold;">Discount</div>
              {{ getSelectedOffer.offer_title || getSelectedOffer.voucher_title }}
            </td>
            <td
              colspan="3"
              style="text-align: right; vertical-align: bottom"
            >{{ getcurrency }} {{ offerPrice }}</td>
          </tr>

          <tr>
            <td colspan="5">
              <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">PAYMENTS:</p>
            </td>
          </tr>

          <tr>
            <td colspan="2" style="text-align:left;">{{ paymentDetails.pm_payment_mode }}</td>
            <td colspan="3" style="text-align:right;">{{getcurrency}} {{ totalAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
          </tr>

          <tr>
            <td colspan="5" style="padding-top:15px;border-bottom:1px dashed #404040;"></td>
          </tr>

          <tr>
            <td colspan="1" style="text-align:left;font-weight:bold;">NET PRICE</td>
            <td colspan="2" style="text-align:center;font-weight:bold;">TAX</td>
            <td colspan="2" style="text-align:right;font-weight:bold;">AMOUNT</td>
          </tr>

          <tr>
            <td colspan="5" style="border-top:1px dashed #404040;"></td>
          </tr>

          <tr>
            <td colspan="1" style="text-align:left;">
              <p style="margin: 2px  0;">{{ netAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
            <td colspan="2" style="text-align:center;">
              <p style="margin:2px 0;">{{ getTaxAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
            <td colspan="2" style="text-align:right;">
              <p style="margin:2px 0;">{{getcurrency}} {{ totalAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="5">
              <p style="margin: 15px 0 0 0;;">Sold By: {{ name }}</p>
              <p
                style="margin: 3px 0;"
              >Sold on: {{ hardwarename && hardwarename.length > 0 ? hardwarename : '-' }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      currentDate: "",
      TaxAmountValue: "",
      name: "",
      pos_hardware_name: "",
      EjsData: null
    };
  },
  computed: {
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;
      toString;
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(this.MIN_FRACTION_DIGITS) : 0;
    },
    paymentDetails() {
      return this.$store.getters.selectedPaymentMode;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    getSelectedArray() {
      let array = [];
      if (
        this.bookingDetails &&
        this.bookingDetails["seats_types"] &&
        this.bookingDetails["seats_types"].length > 0
      ) {
        this.bookingDetails.seats_types.map(x => {
          x.seats.map(y => {
            array.push({
              seatName: y,
              seatType: x.seat_type
            });
          });
        });
      }
      return array;
    },
    getTaxesNames() {
      let taxName = [];
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          taxName.push(e.ct_name);
        });
        return taxName;
      } else {
        return "No Charges";
      }
    },
    getTaxAmount() {
      let TaxValue = null;

      console.log("this.AdditionalCharges :", this.AdditionalCharges);
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          TaxValue += e.sp_value;
        });
        return TaxValue;
      } else {
        return (TaxValue = 0.0);
      }
    },
    getTotal() {
      let Total = null;

      Total = this.netAmount + this.getTaxAmount;
      return Total;
    },
    totalAmount() {
      return this.getOfferPrice > 0
        ? this.$store.getters.TOTAL_AMOUNT - this.getOfferPrice
        : this.$store.getters.TOTAL_AMOUNT;
    },
    tickettotal() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    hardwarename() {
      return this.$store.getters.gethardwarename;
    },
    ...mapGetters([
      "getOfferPrice",
      "getSelectedOffer",
      "getOfferFor",
      "IDforBoxOfficeEjs",
      "IDforFnBEjs"
    ])
  },
  beforeMount() {
    this.currentDate = moment().format("DD/MM/YY HH:mm");
    const { cinema_id } = this.secureStore.get("USINFO");
    this.name = this.secureStore.get("USINFO").first_name;
  },
  mounted() {
    EventBus.$on("printSalesReceipt", () => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printSalesReceipt");
  },
  methods: {
    GetEjsTicket: function() {
      let loader = this.$loading.show();

      PosService.GetReceiptEjs(
        this.IDforBoxOfficeEjs.sb_id,
        0,
        this.IDforBoxOfficeEjs.cinema_id,
        "BoxOfficeReceipt"
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.SalesReceipt) {
        p.print(this.$refs.SalesReceipt, []);
      }
    }
  }
};
</script>

<style>
table,
td,
th {
  padding: 8px;
}
</style>
 





// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/ReceiptTemplates/sales_receipts.vue